<template>
  <div aria-hidden="true" class="base-label align-self-end" :class="{'mt-2': !disableMargin}">
    <span 
      class="base-label__maintext font-weight-bold"
      v-bind:class="{ 'large-font-size': large, 
                      'extra-large-font-size': extraLarge, 
                      'text-subtitle-2': !large && !extraLarge}"
    > 
      <slot>
        {{ rawText ? label : capitalize(label) }}{{ required ? "*" : "" }}{{ optional ? ` (${$t('general.optional')})` : "" }}
      </slot>
    </span>
    <span class="base-label__hinttext d-block text-caption">
      <slot name="hint">
        {{ hint }}
      </slot>
    </span>
  </div>
</template>
<script>
// TODO: make functional component (or wait for Vue 3)
import { capitalize } from 'lodash';

export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    hint: {
      type: String,
      default: '',
    },
    rawText: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false
    },
    optional: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    extraLarge: {
      type: Boolean,
      default: false
    },
    disableMargin: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    capitalize,
  },
};
</script>

<style lang="scss" scoped>
.base-label {
  color: var(--v-formLabel-base);

  &__maintext {
    opacity: 0.87;
  }

  &__hinttext {
    display: block;
    opacity: 0.66;
  }

  .custom-label {
    color: var(--v-heading-base);
  }
}
</style>
<style lang="css" scoped>
  .large-font-size {
    font-size: 1.3em;
    font-weight: 500;
  }
  .extra-large-font-size {
    font-size: 1.6em;
    font-weight: 500;
  }
</style>